export const environment = {
    production: false,
    apiKey: '<API_KEY>',
    apiUrl: 'https://api.test.fleet-emissions.fi',
};
